<template>
	<div class="ao-mobile-select-layout">
		<div class="d-flex align-start">
			<div class="flex-grow-1">
				<slot
					name="activator"
				/>
				<slot
					name="errors"
				/>
			</div>
			<slot
				name="addAction"
			/>
		</div>
		<AoBottomSheet
			:modelValue="modelValue"
			:title="label"
			:swipeToClose="isListScrolledToTop"
			showCloseButton
			bodyFlexLayout
			@update:modelValue="$emit('update:modelValue', $event)"
		>
			<slot
				name="default"
			/>
			<!-- <div class="d-flex flex-column fill-height">
			</div> -->
		</AoBottomSheet>
	</div>
</template>

<script setup>
import AoBottomSheet from '../AoBottomSheet.vue'

defineProps({

	modelValue: {
		type: Boolean,
		required: true,
	},

	disabled: {
		type: Boolean,
		default: false,
	},

	label: {
		type: String,
		default: null,
	},

	isListScrolledToTop: {
		type: Boolean,
		default: true,
	},

})

defineEmits({
	'update:modelValue': null,
})

</script>
